import React from 'react';
import Slider from 'react-slick'

function Testimonial() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 4000,
    autoplay: false,
    arrows: false,
    autoplaySpeed: 4000,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 1000,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          speed: 1000,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          speed: 1000,
        }
      },
    ]
  }
  return (
    <section className="testimonial-area testimonial-bg">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title text-center mb-65">
              <div className="section-icon"><img src="img/icon/pawprint_blue.png" alt="" /></div>
              <h5 className="sub-title">Témoignages</h5>
              <h2 className="title">Nos Clients Heureux</h2>
              <p>Découvrez ce que nos clients disent de nous et de leurs nouveaux compagnons.</p>
            </div>
          </div>
        </div>
        <Slider className="row testimonial-active"{...settings}>
          <div className="col">
            <div className="testimonial-item">
              <div className="testi-avatar-thumb">
                <img src="img/images/avatar.png" alt="" />
              </div>
              <div className="testi-content">
                <p>“ Bil7a9 5edma ndhifa w en plus mezyanin w dafdoufin merci encore une fois 🥰”</p>
                <div className="testi-avatar-info">
                  <h5 className="title">Anonyme</h5>
                  <span>Cliente</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="testimonial-item">
              <div className="testi-avatar-thumb">
                <img src="img/images/avatar.png" alt="" />
              </div>
              <div className="testi-content">
                <p>“ Ce sweat lui va parfaitement 🥰🥰 merci beaucoup et à la prochaine ”</p>
                <div className="testi-avatar-info">
                  <h5 className="title">Anonyme</h5>
                  <span>Cliente</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="testimonial-item">
              <div className="testi-avatar-thumb">
                <img src="img/images/avatar.png" alt="" />
              </div>
              <div className="testi-content">
                <p>“ Merte7 feha aalekher 😂 Ki na7iwhelou il lui donne des bisous 😂😂”</p>
                <div className="testi-avatar-info">
                  <h5 className="title">Anonyme</h5>
                  <span>Cliente</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="testimonial-item">
              <div className="testi-avatar-thumb">
                <img src="img/images/avatar.png" alt="" />
              </div>
              <div className="testi-content">
                <p>“ Wesltni commande merci beaucoup yecer mezyenin ❤️❤️”</p>
                <div className="testi-avatar-info">
                  <h5 className="title">Anonyme</h5>
                  <span>Cliente</span>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  )
}

export default Testimonial;
